import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { Trade } from '../../common/_types/trade';
import { TradesService } from '../../common/_services/trades.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-trades-list',
    templateUrl: './trades-list.component.html',
    styleUrls: ['./trades-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TradesListComponent {
  public trades: Trade[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private tradesService: TradesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.topbarService.setTitle("Ramos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as Trade);
    });
    this.allowWrite =  this.loginService.hasPermission("TRADES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRADES.DELETE");
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    };

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.tradesService.all(params));
    this.trades = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(trade: Trade | null, source?: string) {
    this.router.navigate(['trades/' + (trade && Object.keys(trade).length > 0 ? trade.id : 0) + (source ? '/' + source : '')]);
  }

  delete(trade: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el oficio?",
        header: "Eliminar oficio",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.tradesService.delete(trade.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Oficio eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
